<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
      :background-color="sidebarBackground"
      short-title=""
      title=""
    >
      <template slot="links">
        <sidebar-item
          :link="{
            name: 'Dashboard',
            icon: 'fa fa-star text-blue text-primary',
            path: '/dashboard'
          }"
        />

        <!--<sidebar-item :link="{name: 'Icons', icon: 'ni ni-planet text-blue', path: '/icons'}"/>-->
        <!-- <sidebar-item 
          :link="{
            name: 'User Management', 
            icon: 'ni ni-planet text-blue', 
            path: '/user-management',
            children: [
              {
                name: 'Candidate',
                icon: 'ni ni-planet text-blue', 
                path: '/candidate'
              }
            ]
          }"
        /> -->
        <!-- <li class="nav-item"> -->
          <!-- <i class="fa fa-star text-blue"></i>
          <span class="nav-link-text">User Management</span> -->
          <li class="nav-item">
            <a id="userManagementToggle" v-on:click="toggleUserManagement()" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="userManagement" class="nav-link">
              <!--<i class="fa fa-star text-blue"></i>-->
              <i></i>
              <span class="nav-link-text">User Management</span> 
            </a>
            <ul id="userManagement" class="navbar-nav nav collapse">
              <sidebar-item :link="{name: 'Candidate', path: {path: '/candidate', query: {page: 1}}}"/>
              <sidebar-item :link="{name: 'Employer', path: {path: '/employer', query: {page: 1}}}"/>
            </ul>
          </li>
        
        <sidebar-item :link="{name: 'Credit Packages', icon: 'fa fa-star text-blue', path: {path: '/credit-packages', query: {page: 1}}}" />
        <sidebar-item :link="{name: 'Job Applications', icon: 'fa fa-star text-blue', path: {path: '/job-applications', query: {page: 1}}}" />
        <sidebar-item :link="{name: 'Find Talents', icon: 'fa fa-star text-blue', path: {path: '/find-talents', query: {page: 1}}}" />
        <sidebar-item :link="{name: 'Articles', icon: 'fa fa-star text-blue', path: {path: '/articles', query: {page: 1}}}" />
        <sidebar-item :link="{name: 'Announcements', icon: 'fa fa-star text-blue', path: {path: '/push-notifications', query: {page: 1}}}" />
        <!--<sidebar-item :link="{name: 'Static Contents', icon: 'ni ni-pin-3 text-orange', path: '/static-contents'}" />-->
        <!--<sidebar-item :link="{name: 'Settings', icon: 'ni ni-pin-3 text-orange', path: '/settings'}" />-->
        

        <li class="nav-item">
          <a id="staticContentsToggle" v-on:click="toggleStaticContents()" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="staticContents" class="nav-link">
            <!-- <i class="fa fa-star text-blue"></i> -->
            <i></i>
            <span class="nav-link-text">Static Contents</span> 
          </a>
          <ul id="staticContents" class="navbar-nav nav collapse">
            <sidebar-item :link="{name: 'Employer Content', path: {path: '/employer-static-contents', query: {page: 1}}}" />
            <sidebar-item :link="{name: 'Candidate Content', path: {path: '/candidate-static-contents', query: {page: 1}}}" />
          </ul>
        </li>

        <li class="nav-item">
          <a id="settingsToggle" v-on:click="toggleSettings()" data-toggle="collapse" role="button" aria-expanded="false" aria-controls="settings" class="nav-link">
            <!-- <i class="fa fa-star text-blue"></i> -->
            <i></i>
            <span class="nav-link-text">Settings</span> 
          </a>
          <ul id="settings" class="navbar-nav nav collapse">
            <sidebar-item :link="{name: 'Selections', path: {path: '/selections', query: {page: 1}}}" />
            <sidebar-item :link="{name: 'App Versions', path: {path: '/app-versions', query: {page: 1}}}" />
          </ul>
        </li>

        <!-- <sidebar-item :link="{name: 'Maps', icon: 'ni ni-pin-3 text-orange', path: '/maps'}"/>
        <sidebar-item :link="{name: 'User Profile', icon: 'ni ni-single-02 text-yellow', path: '/profile'}"/>
        <sidebar-item :link="{name: 'Tables', icon: 'ni ni-bullet-list-67 text-red', path: '/tables'}"/>
        <sidebar-item :link="{name: 'Login', icon: 'ni ni-key-25 text-info', path: '/login'}"/>
        <sidebar-item :link="{name: 'Register', icon: 'ni ni-circle-08 text-pink', path: '/register'}"/> -->

      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
        <content-footer v-if="!$route.meta.hideFooter"></content-footer>
      </div>
    </div>
  </div>
</template>
<script>
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import EditAdminProfile from './../views/Modals/EditAdminProfile.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition
    },
    data() {
      return {
        sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
      };
    },
    methods: {
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },

      toggleUserManagement() {
        if ($('#userManagement').css('display') == 'none') {
          $('#userManagementToggle').attr("aria-expanded", "true");
          $('#userManagement').show();
        } else {
          $('#userManagementToggle').attr("aria-expanded", "false");
          $('#userManagement').hide();
        }
      },

      toggleStaticContents() {
        if ($('#staticContents').css('display') == 'none') {
          $('#staticContentsToggle').attr("aria-expanded", "true");
          $('#staticContents').show();
        } else {
          $('#staticContentsToggle').attr("aria-expanded", "false");
          $('#staticContents').hide();
        }
      },

      toggleSettings() {
        if ($('#settings').css('display') == 'none') {
          $('#settingsToggle').attr("aria-expanded", "true");
          $('#settings').show();
        } else {
          $('#settingsToggle').attr("aria-expanded", "false");
          $('#settings').hide();
        }
      }
    }
  };
</script>
<style lang="scss">
</style>
